import type { CSSProperties } from 'react';

import { nl2br } from '../../utils/index';
import { FontVariant } from '../../styles/style.interfaces';

import styles from './Paragraph.module.css';

type ParagraphStyleProps = {
  fontSize?: number | string;
  marginBottom?: number | string;
  maxWidth?: number | string;
  textAlign?: CSSProperties['textAlign'];
  fontVariant?: FontVariant;
};

interface Props extends ParagraphStyleProps {
  texts: string;
}

function toCssValue(v: number | string | undefined): string | undefined {
  if (v === undefined) return undefined;
  return typeof v === 'number' ? `${v}px` : v;
}

export default function Paragraph({ texts, fontVariant = 'default', ...styleProps }: Props) {
  const fontClass = fontVariant === 'alt' ? 'fontVariantAlt' : 'fontVariantDefault';
  const style: CSSProperties = {
    fontSize: toCssValue(styleProps.fontSize),
    marginBottom: toCssValue(styleProps.marginBottom),
    maxWidth: toCssValue(styleProps.maxWidth),
    textAlign: styleProps.textAlign,
  };

  return (
    <p className={`${styles.paragraph} ${fontClass}`} style={style}>
      {nl2br(texts)}
    </p>
  );
}
